var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTitlesOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#878793;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.51,14.44a4.13,4.13,0,1,0-4.13-4.13A4.14,4.14,0,0,0,7.51,14.44Zm6-5.32h5.89a.89.89,0,0,0,0-1.77H13.48a.89.89,0,0,0,0,1.77ZM7.05,12.73a.72.72,0,0,1-.55-.21L5.08,11a.7.7,0,0,1-.2-.47.67.67,0,0,1,.7-.69.69.69,0,0,1,.5.2l.91,1L8.87,8.48a.7.7,0,0,1,.57-.3.68.68,0,0,1,.68.69.65.65,0,0,1-.12.38L7.61,12.48A.71.71,0,0,1,7.05,12.73Zm6.43.48h5.89a.88.88,0,1,0,0-1.76H13.48a.88.88,0,1,0,0,1.76Zm-9.21,4.6h15.1a.89.89,0,0,0,0-1.77H4.27a.89.89,0,1,0,0,1.77Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTitlesOn);
export default __webpack_public_path__ + "static/media/icon-titles-on.4e7d31f55282aa27b76321c053d631c7.svg";
export { ForwardRef as ReactComponent };